import { usePulse } from "@/hooks/use-pulse";
import { useT } from "@/i18n/useT";
import { WATCH_KEYS } from "@/config/fng";

interface PulseStripProps {
  contextPulse?: string;
}

export default function PulseStrip({ contextPulse }: PulseStripProps) {
  const { data } = usePulse();
  const { t } = useT();

  // Priority 1: AI-generated natural language pulse
  if (contextPulse) {
    return (
      <span className="text-[10px] text-muted-foreground/90 font-medium tracking-wider uppercase leading-relaxed text-center">
        <span className="font-semibold">{t("pulseLabel")}</span>{" "}
        {contextPulse.toLowerCase()}
      </span>
    );
  }

  // Priority 2: Structured watch label fallback
  if (!data || data.watch === "normal") return null;

  const watchKey = WATCH_KEYS[data.watch as keyof typeof WATCH_KEYS];
  const label = watchKey ? t(watchKey) : data.watch;
  const regimeSuffix = data.regime_duration >= 2 ? ` · ${t("regimeSuffix", { days: data.regime_duration })}` : "";

  return (
    <span className="inline-flex items-center justify-center text-[10px] text-muted-foreground/90 font-medium tracking-wider uppercase">
      <span className="font-semibold">{t("pulseLabel")}</span>&nbsp;{label}{regimeSuffix}
    </span>
  );
}
